import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.div`
  padding: 3rem 0;

  border-bottom: 0.2rem solid ${pickColor('gray')};
  display: flex;
  gap: 1.2rem;
  align-items: center;
  justify-content: space-between;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.6rem;
`;

const Info = styled.div``;

const IconWrapper = styled.div`
  display: flex;
`;

const Wrapper = styled.div`
  display: flex;
  gap: 0.6rem;
`;

const FlexItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;

  margin-bottom: 0.6rem;

  color: ${pickColor('grayLabel')};

  &:not(:first-child) {
    &::before {
      content: '/';
    }
  }
`;

const Desc = styled.div`
  max-width: 65rem;
`;

const CTA = styled.div`
  display: flex;

  justify-content: flex-end;

  gap: 1.2rem;
`;

export { Container, CTA, Desc, FlexItem, Header, Info, IconWrapper, Wrapper };
